export { SkillDependable as default } from './SkillDependable';
